import { updateArtist } from '@disco/state-management/actions/artist-actions'
import { getArtist } from '@disco/state-management/selectors/artists'

import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import { useLocation, useParams, Outlet } from 'react-router-dom'
import type { Artist, ArtistId } from 'types/artist'
import type { State } from 'types/redux'
import ArtistProfile from 'components/modals/artist/profile'

const LibrariesArtistsArtistProfile = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ artistId: string }>()
  const artistId: ArtistId = parseInt(params.artistId!, 10)
  const artist: Artist = useSelector((state: State) =>
    getArtist(state, artistId),
  )
  const handleCancel = useCallback(() => {
    const returnTo = '/catalogs/artists'
    navigate(location.state?.returnTo ?? returnTo)
  }, [dispatch, location])

  const handleSubmit = (data: Partial<Artist>) => {
    return dispatch(updateArtist(artistId, data))
  }

  return (
    <>
      {artist && (
        <ArtistProfile
          artist={artist}
          onCancel={handleCancel}
          onSubmit={handleSubmit}
        />
      )}
      <Outlet />
    </>
  )
}

export default LibrariesArtistsArtistProfile
